/**
 * Responsibility: Implement world sim quests behavior for the engine layer.
 * Scope: Owns engine-layer concerns only; cross-layer orchestration is excluded.
 */
import type { QuestStatus } from "@anyquest/shared-core"

export function canWorldTickSetQuestStatus(newStatus: QuestStatus): boolean {
  return newStatus !== 'completed'
}
